(function () {
  'use strict';

  function updateProductCard(select) {
    if (!select) return;

    const card = select.closest('[data-product-card]');
    if (!card) return;

    const option = select.options[select.selectedIndex];
    if (!option) return;

    const variantId =
      option.dataset.variantId || option.value;

    const price =
      option.dataset.price || '';

    const comparePrice =
      option.dataset.variantComparePrice || '';

    const priceNumber =
      Number(option.dataset.priceNumber || 0);

    const comparePriceNumber =
      Number(option.dataset.comparePriceNumber || 0);

    const available =
      option.dataset.available === 'true';


    /* ---------------------------------------------
       ELEMENTS
    --------------------------------------------- */

    const variantInput =
      card.querySelector('[data-girlit-variant-id]');

    const priceElement =
      card.querySelector('[data-product-price]');

    const compareElement =
      card.querySelector('[data-product-compare-price]');

    const discountElement =
      card.querySelector('[data-product-discount]');

    const button =
      card.querySelector('[data-add-to-cart]');

    const buttonText =
      card.querySelector('[data-atc-text]');


    /* ---------------------------------------------
       VARIANT ID
    --------------------------------------------- */

    if (variantInput && variantId) {
      variantInput.value = String(variantId);
      variantInput.setAttribute(
        'value',
        String(variantId)
      );
    }


    /* ---------------------------------------------
       SELLING PRICE
    --------------------------------------------- */

    if (priceElement) {
      priceElement.textContent = price;
    }


    /* ---------------------------------------------
       COMPARE-AT PRICE
    --------------------------------------------- */

    const isOnSale =
      comparePriceNumber > priceNumber &&
      comparePriceNumber > 0;

    if (compareElement) {

      if (isOnSale) {

        compareElement.textContent =
          comparePrice;

        compareElement.classList.remove(
          'is-hidden'
        );

      } else {

        compareElement.textContent = '';

        compareElement.classList.add(
          'is-hidden'
        );
      }
    }


    /* ---------------------------------------------
       DISCOUNT
    --------------------------------------------- */

    if (discountElement) {

      if (isOnSale) {

        const discount =
          Math.round(
            (
              (comparePriceNumber - priceNumber)
              / comparePriceNumber
            ) * 100
          );

        if (discount > 0) {

          discountElement.textContent =
            discount + '% OFF';

          discountElement.classList.remove(
            'is-hidden'
          );

        } else {

          discountElement.textContent = '';

          discountElement.classList.add(
            'is-hidden'
          );
        }

      } else {

        discountElement.textContent = '';

        discountElement.classList.add(
          'is-hidden'
        );
      }
    }


    /* ---------------------------------------------
       AVAILABILITY
    --------------------------------------------- */

    if (button) {

      button.disabled = !available;

      button.setAttribute(
        'data-variant-id',
        variantId
      );
    }

    if (buttonText) {

      buttonText.textContent =
        available
          ? 'ADD TO CART'
          : 'SOLD OUT';
    }


    /* ---------------------------------------------
       SAVE CURRENT VARIANT
    --------------------------------------------- */

    card.setAttribute(
      'data-selected-variant',
      variantId
    );

    card.dataset.selectedVariantPrice =
      String(priceNumber);

    card.dataset.selectedVariantComparePrice =
      String(comparePriceNumber);

    card.dataset.selectedVariantAvailable =
      String(available);
  }


  /* =============================================
     VARIANT CHANGE
     ============================================= */

  document.addEventListener(
    'change',
    function (event) {

      const select =
        event.target.closest(
          '[data-variant-select]'
        );

      if (!select) return;

      updateProductCard(select);
    }
  );


  /* =============================================
     BEFORE SUBMIT
     FORCE CURRENT VARIANT
     ============================================= */

  document.addEventListener(
    'submit',
    function (event) {

      const form =
        event.target.closest(
          '.girlit-product-card__form'
        );

      if (!form) return;

      const select =
        form.querySelector(
          '[data-variant-select]'
        );

      const variantInput =
        form.querySelector(
          '[data-girlit-variant-id]'
        );

      if (!select || !variantInput) return;

      const option =
        select.options[
          select.selectedIndex
        ];

      if (!option) return;

      const variantId =
        option.dataset.variantId ||
        option.value;

      variantInput.value =
        String(variantId);

      variantInput.setAttribute(
        'value',
        String(variantId)
      );
    }
  );


  /* =============================================
     INITIAL LOAD
     ============================================= */

  function initialise() {

    document
      .querySelectorAll(
        '[data-variant-select]'
      )
      .forEach(function (select) {

        updateProductCard(select);

      });
  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialise
    );

  } else {

    initialise();

  }


  /* =============================================
     SHOPIFY DYNAMIC SECTIONS
     ============================================= */

  document.addEventListener(
    'shopify:section:load',
    initialise
  );

})();